import { useRouter } from 'next/router';
import qs from 'query-string';
import { BASE_URLS } from '../consts/baseProductUrls';
/**
 * In order to have a consistent base url, we need this hook in case a1click campaign is set
 * @returns void
 */
export const useInitialRoute = () => {
  const router = useRouter();
  const pushToInitialRoute = () => {
    const query = qs.extract(router.asPath)?.length
      ? qs.extract(router.asPath)
      : qs.stringify({
          m_campaign:
            window.sessionStorage.getItem('campaign') !== null
              ? window.sessionStorage.getItem('campaign')
              : undefined,
          m_src:
            window.sessionStorage.getItem('source') !== null
              ? window.sessionStorage.getItem('source')
              : undefined,
        });
    const baseUrl =
      typeof window !== 'undefined' &&
      window.sessionStorage.getItem('campaign') === 'a1click'
        ? BASE_URLS.A1
        : BASE_URLS.default;
    router.push(`${baseUrl}${query && `?${query}`}`);
  };
  return { pushToInitialRoute };
};
